import { Grid2 } from "@mui/material";
import { Link, useNavigate } from "react-router-dom";
import logo from "../../../../../../assets/logos/admin_logo.svg";
import ReconcilliationConfirmTable from "../../../../../../components/ReconcilliationConfirmTable/ReconcilliationConfirmTable";

const SiteReturnDepotConfirmPage = ({
  setShowConfirm,
  data,
  siteId,
  siteName,
}) => {
  const navigate = useNavigate();

  const email = localStorage.getItem("email");

  return (
    <>
      <div className="content-body">
        <p
          className="bread-crumbs-link-container"
          style={{ fontWeight: "600" }}
        >
          <Link className="bread-crumbs-link" to="/">
            Home
          </Link>{" "}
          |{" "}
          <Link className="bread-crumbs-link" to="/site-management">
            Site Management
          </Link>{" "}
          |
          <button
            className="bread-crumbs-btn"
            onClick={(e) =>
              navigate("/addUpdate-site-management", {
                state: { id: siteId },
              })
            }
          >
            {siteName || "Site Details"}
          </button>
          |{" "}
          <button
            className="bread-crumbs-btn"
            onClick={(e) =>
              navigate("/site-management-site-return-depot", {
                state: { id: siteId, name: siteName },
              })
            }
          >
            Site Return To Depot Confirmation
          </button>
          -{" "}
          <b style={{ color: "gray" }}>
            {localStorage?.getItem("studyName")}
          </b>
        </p>
        <Grid2
          container
          alignItems="center"
          justifyContent="space-between"
          sx={{ width: "100%", margin: "0 auto" }}
        >
          <Grid2 item md={6}>
            <p className="page-heading">
              Dev-Genesis StudyPortal Confirmation of Site IP Return to Depot
            </p>
          </Grid2>
        </Grid2>
        <div className="heading-container">
          <h4>Confirmation of Site IP Return to Depot Genesis StudyPortal</h4>
        </div>
        <div className="inner-heading-container">
          <img
            className="admin-logo logo-image"
            src={logo}
            alt="Genesis Logo"
          />
          <div className="data-block">
            <div className="data-inner-block">
              <span className="data-inner-block-text">User Name : </span>
              <span style={{ color: "white" }}> {email}</span>
            </div>

            <div className="data-block">
              <span className="data-inner-block-text">
                System Transaction Date :
              </span>
              <span style={{ color: "white" }}>
                {" "}
                {new Date().toLocaleDateString()}
              </span>
            </div>

            <div className="data-inner-block">
              <span className="data-inner-block-text">
                Site Transaction Date :
              </span>
              <span style={{ color: "white" }}>
                {" "}
                {new Date().toLocaleDateString()}
              </span>
            </div>
          </div>
        </div>

        <div
          style={{
            maxHeight: "500px",
            overflowY: "auto",
          }}
        >
          <ReconcilliationConfirmTable data={data} />
        </div>

        <div className="note-container">
          <span
            style={{
              fontWeight: "600",
              color: "#585858",
            }}
          >
            Note :
          </span>
          <span>
            This site study drug return to depot has been recorded successfully.
          </span>
        </div>
        <div
          style={{
            height: "20px",
          }}
        ></div>
        <div className="footer-container">
          <span>
            Genesis 2025-Please contact Genesis Support for assistance at
            Genesis.com/support
          </span>
        </div>
        <Grid2
          alignItems={"center"}
          justifyContent="center"
          container
          gap={3}
          sx={{ marginTop: "2%" }}
        >
          <Grid2 item md={6}>
            <button
              className="create-btn"
              onClick={() => {
                navigate("/");
              }}
            >
              Home
            </button>
          </Grid2>
        </Grid2>
      </div>
    </>
  );
};

export default SiteReturnDepotConfirmPage;
